module.exports = __webpack_public_path__ + "img/Bookmark-Spanish-Logo-1000-admin.1705cbdb.png";